/* tslint:disable */

/**
 * Status of the delivery:
 *   * DRAFT
 *   * PUBLISHED
 *   * DELIVERED
 */
type DeliveryStatus =
  'DRAFT' |
  'PUBLISHED' |
  'DELIVERED';
namespace DeliveryStatus {
  export const DRAFT: DeliveryStatus = 'DRAFT';
  export const PUBLISHED: DeliveryStatus = 'PUBLISHED';
  export const DELIVERED: DeliveryStatus = 'DELIVERED';
  export function values(): DeliveryStatus[] {
    return [
      DRAFT,
      PUBLISHED,
      DELIVERED
    ];
  }
}

export { DeliveryStatus }